import {  Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder,  Validators, ValidatorFn } from "@angular/forms";
import { Subscription, Observable, of, from } from 'rxjs';
import { take, concatMap, toArray, catchError } from 'rxjs/operators';
import { EditorComponent } from "@progress/kendo-angular-editor";
import { UploadImageDialogComponent } from "editor-library";
import { ToastrService } from 'ngx-toastr';
import { EmailClientService } from "../service/email-client.service";
import { GoogleApiService } from "../../scheduling/google-api.service";
import {createMimeMessage} from 'mimetext';
import { Buffer } from 'buffer';
import { CustomErrorToastComponent } from "custom-error-toast";

@Component({
  selector: "google-compose-email",
  templateUrl: "./google-compose-email.component.html",
  styleUrls: ["./google-compose-email.component.scss"],
})
export class GoogleComposeEmailComponent implements OnInit,OnDestroy {
  commonkendoeditorStr: string;
  @Output() @ViewChild("commonkendoeditor") public commonkendoeditor: EditorComponent;
  @ViewChild("commonkendoeditorupload") public commonkendoeditorupload: UploadImageDialogComponent;
  // @Output()deleteMailDetails = new EventEmitter<any>()
  replyForm: FormGroup;
  discardDialog: boolean = false;
  userName:string='';
  userEmail:string='';
  submitted:boolean = false;
  replyType:string='';
  uploadedFile: any;
  attachFileList:any[]=[];
  mailId:string='';
  subjectId:string='';
  uploadedFiles$: Observable<any>;
  acceptedFiles: string = ".pdf, .jpg, .png, .doc, .docx, .xls, .xlsx, .csv";
  emailDetailSubscription: Subscription;
  emailObject:any = {};
  threadId:string='';
  attachmentData:string[]=[];
  priorityList = [
    {
      name: "Normal",
      code: "normal",
    },
    {
      name: "High",
      code: "high",
    },
    {
      name: "Low",
      code: "low",
    },
  ];

  constructor(private fb: FormBuilder,
              private toastr: ToastrService,
              private readonly googleApi: GoogleApiService,
              private emailClientService: EmailClientService) {
              const {firstname:userName,communicationEmailId:userEmail} = JSON.parse(sessionStorage.getItem('currentUser'));
    this.userName= userName;
    this.userEmail= userEmail;
    // let emailregex: RegExp = /^([A-Za-z]+[A-Za-z0-9.-_]+@[A-Za-z0-9.-_]+\.[A-Za-z]{2,4}(\s*(,)\s*|\s*$))+$/;
    let emailregex: RegExp = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/; 
    this.replyForm = this.fb.group({
      from: [{ value: this.googleApi.selectedUsername}, [Validators.required, Validators.email]],
      priority: ['normal'],
      to: ['',{
        validators: [Validators.required,Validators.pattern(emailregex),this.checkduplicateEmail()],
        updateOn: 'blur'
      }],
      cc: ['',{
        validators: [Validators.pattern(emailregex),this.checkduplicateEmail()],
        updateOn: 'blur'
      }],
      subject: ['',Validators.required],
      editor:['']
    });
    window['Buffer'] = Buffer;
  }

  ngOnInit(): void {
    let email='';
    this.subjectId ='[3126IMAGILITY]';
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if(userInfo){
          email = userInfo.info.email;
          this.replyForm.get('from').setValue(email);
          this.googleApi.selectedUsername= email;
        }

        if(this.googleApi.selectedReplyType){
          this.getGoogleEmailDetails(email,this.googleApi.selectedEmailId);
        }
        this.subjectId ='[3126IMAGILITY]';

    // this.emailClientService.emailComposeSubscription$.pipe(take(1)).subscribe(data=>{
    //   this.mailId = data['emailId'];
    //   this.replyType = data['replyType'];
    //   if(this.mailId){
    //     // this.getEmailDetails(this.mailId);
    //     if(this.replyType){
    //       this.getGoogleEmailDetails(email,this.googleApi.selectedEmailId);
    //     }
    //   }
    // })
    // this.subjectId = sessionStorage.companyId && sessionStorage.userId ?
    //                 "[IM-"+sessionStorage.companyId+sessionStorage.userId+"]" :
    //                 ""
  
    // let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // if(userInfo){
    //   let email = userInfo.info.email;
    //   // this.getGoogleEmailDetails(email,'1869fb693904f50c');
    // }
    // if(this.googleApi.selectedReplyType){
    //   this.getGoogleEmailDetails(email,this.googleApi.selectedEmailId);
    // }
    

    
  }


   
  getGoogleEmailDetails(email:string,mailId:string){
    this.googleApi.getMail(email,mailId).pipe(take(1)).subscribe(emailData=>{
      emailData = {...emailData,...{'mailId':mailId,'email':email } };
      this.setFormData(emailData);
    })
  }
  
  getEmailDetails(mailId:string){
    this.emailClientService.getMessageDetails(mailId).pipe(take(1)).subscribe(emailData=>{
      this.setFormData(emailData);
    })
  }

  setFormData(emailData:any){
    const filerMsg = emailData.payload.headers.filter(dt=>
      dt.name=="From" || dt.name=="To" ||
      dt.name=="Cc" || dt.name=="Subject" || 
      dt.name=="Date" || dt.name=="Importance" );
    this.emailObject = filerMsg.reduce(
      (obj:any, item:any) => Object.assign(obj, { [item.name]: item.value }), {});
      this.setAttachment(emailData);
      let editorFlag=false;
      try{
        editorFlag = emailData?.payload?.parts[1].body.hasOwnProperty('data');
      }
      catch(e){
        editorFlag =false;
      }
      let editorValue='';
      if(editorFlag){
        let dataBase64Rep = emailData?.payload?.parts[1].body?.data.replace(/-/g, '+').replace(/_/g, '/');
        editorValue = atob(dataBase64Rep);
      }
      else {
        try {
        if (emailData?.payload?.parts[0].mimeType=="multipart/alternative"){
          for(let item of emailData?.payload?.parts[0].parts){
            if(item.mimeType=="text/html"){
              let dataBase64Rep = item?.body?.data.replace(/-/g, '+').replace(/_/g, '/');
              editorValue = atob(dataBase64Rep);
              break;
            }
          }
        }}
        catch(e){ }

        try {
          if(emailData['payload']['body']['data']){
            let dataBase64Rep = emailData['payload']['body']['data'].replace(/-/g, '+').replace(/_/g, '/');
            editorValue = atob(dataBase64Rep);
          }
        }
        catch(e){}
      }

      this.threadId= emailData.threadId;
        this.replyForm.patchValue({
          // from:this.emailObject?.From.replace(/</gi,'').replace(/>/gi,''),
          editor:editorValue, 
          priority:'high',
      })
      this.setReplyData();
  }

  combineEmails(emailAddress: any): string {
    if(emailAddress){
      let emailArr = [];
    var re = /[^< ]+(?=>)/g;
    try{
      emailAddress.match(re).forEach(function(email) {
        emailArr.push(email);
      });
    }
    catch(e){}
    if(!emailAddress.includes("<") && emailAddress!=''){
      emailArr.push(emailAddress);
    } 
    return emailArr.join(',');
    }
    return emailAddress;
  }

  setAttachment(emailData:any){
    let downloadArr=[];
        try{
          emailData['payload']['parts'].forEach(parts=>{
            if(parts.filename){
                downloadArr.push({filename:parts.filename,
                                  attachmentId:parts.body?.attachmentId,
                                  contentType:parts.mimeType,
                                })
            }
          })
        }
        catch(e){}

        from(downloadArr).pipe(concatMap((downloads: string) => {
          if (downloads['attachmentId']) {
            return this.googleApi.getGmailAttachment(emailData.mailId,emailData.email,btoa(downloads['attachmentId']));
          }
          else {
            of([]);
          }
        }),toArray())
      .subscribe((attachments: any) => {
        this.attachmentData= [];
        if(downloadArr.length ===attachments.length){
          for(let index in downloadArr){
            attachments[index]={...attachments[index],
                                name:downloadArr[index]['filename'],
                                contentType:downloadArr[index]['contentType'],
                                contentBytes:attachments[index]['data']
                              }
          }
          this.uploadedFiles$= of(attachments);
          this.attachFileList = attachments;
        }   
      })
  }

  setReplyData(){
      this.replyType=this.googleApi.selectedReplyType || '';
      if(this.replyType=='replyAll'){
        let emailToAppend='';
        let emailCcAppend='';
        if(this.emailObject.From && this.emailObject.To){
          emailToAppend = this.emailObject.To.includes(this.emailObject.From) 
                              ? this.emailObject.To
                              : this.emailObject.To +","+ this.emailObject.From
        }
        if(this.emailObject.From && this.emailObject.Cc){
          emailCcAppend = this.emailObject.Cc.includes(this.emailObject.From) 
                              ? this.emailObject.Cc
                              : this.emailObject.Cc +","+ this.emailObject.From 
        }
        this.replyForm.patchValue({
          to:this.combineEmails(emailToAppend),
          cc:this.combineEmails(emailCcAppend),
          subject:"RE: " + this.emailObject?.Subject,
        })
      } else if(this.replyType=='reply'){
        this.replyForm.patchValue({
          to:this.combineEmails(this.emailObject?.From),
          cc:'',
          subject:"RE: " + this.emailObject?.Subject
        })
      }  
      else if(this.replyType=='forward'){
        this.replyForm.patchValue({
          to:'',
          cc:'',
          subject:"FW: " + this.emailObject?.Subject
      })
    }
  }

  commonForSaveAndSend():any{
        let composeFormData =  this.replyForm.value;
        this.googleApi.selectedReplyType=''; // reset reply
        let toEmails= composeFormData.to? composeFormData.to.split(',') :'' ;
        let ccEmails= composeFormData.cc ?composeFormData.cc.split(',') : '';
        const disclaimerMsg ="Removing Id between square bracket will be loose entire chain,please don't delete it.";
        const disclaimer=`\n<font color='black'><b>Disclaimer</b>:${disclaimerMsg}</font>`; 
        let messages:any = createMimeMessage();
        messages.setSender(composeFormData.from);
        messages.setTo(toEmails);
        messages.setHeaders({'Importance':composeFormData.priority});
        if(ccEmails){
          messages.setCc(ccEmails);
        }
        if(this.replyType){
          messages.setSubject(composeFormData.subject);
        }
        else {
          messages.setSubject(this.subjectId + " " +composeFormData.subject);
        }
        for(let item of this.attachFileList){
          messages.setAttachment(item.name, item.contentType, item.contentBytes)
        }
        if(composeFormData.editor.includes(disclaimerMsg)){
          messages.setMessage('text/html', composeFormData.editor);
        }
        else {
          messages.setMessage('text/html', composeFormData.editor+"<br>"+disclaimer);
        }
        return messages;
  }

  onSave(){
        this.submitted = true;
        if (this.replyForm.valid) {
        let messages =this.commonForSaveAndSend();
        let messageBody = {
          'message': {
              raw: messages.asEncoded()
          }
        }
        if(this.replyType){
          messageBody['threadId'] = this.threadId
        }
        this.googleApi.SaveEmail(this.replyForm.value.from,messageBody)
        .subscribe((message: any) => {
          if(message.status===200){
            this.toastr.success("Email Saved successfully.", 'Success');
            this.emailClientService.emailDetailSubscription$.next(
              {read:false, emailType: 'Drafts' });
          }
        },
        (error)=>{
          CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while sending email.');
        }
        );
      }
    else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'please fill all mandatory filelds.');
    }        
}


deleteFile(index:number){
  this.uploadedFiles$.subscribe(attachmentData=>{
    attachmentData.splice(index,1);
    this.uploadedFiles$ = of(attachmentData);
    this.attachFileList = attachmentData;
  })
}

onSend() {
  this.submitted = true;
  if (this.replyForm.valid) {
  let composeFormData =  this.replyForm.value;
  this.googleApi.selectedReplyType=''; 
  let messages= this.commonForSaveAndSend();
  let messageBody = {
    raw: messages.asEncoded()
  }
  if(this.replyType){
    messageBody['threadId'] = this.threadId
  }
  

  this.googleApi.SendEmail(composeFormData.from,messageBody)
  .subscribe((message: any) => {
    if(message.status===200){
      if(this.replyType){
        if(this.googleApi.preservedMsgTypeForDraft=="DRAFT"){
          // Delete email from draft and send new based on exiting mail.
          this.googleApi.preservedMsgTypeForDraft='';
          this.toastr.success("Email sent successfully.");
          this.deleteEmailFromDraftFolder(this.threadId);
        }
        else {
          this.toastr.success("Reply sent successfully.");
        }
      }
      else{
        this.toastr.success("Email sent successfully.");
      }
      this.emailClientService.emailDetailSubscription$.next(
        {read:false, emailType: 'Sent Items' });
    }
  },
  (error)=>{
    CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while sending email.');
  }
  );
}
  else {
    CustomErrorToastComponent.showErrorToast(this.toastr, 'please fill all mandatory filelds.');
  }
}

async deleteEmailFromDraftFolder(messageId:string){
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const userId =userInfo.info.email; 
  await this.googleApi.deleteEmailPermanently(userId,messageId)
    .pipe(
      catchError(error => {
        return of([]);
      })
    )
    .toPromise().then(() =>{
      console.log("Deleted Successfully.");
    })
    .catch((err) => { 
      console.log(err);
    });
  }

  onCancel() {
    this.discardDialog = true;
  }

  getBase64(file:File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  Upload(event, fileUpload) {
    fileUpload.clear();
    const fileArr = Array.from(event.files);
    fileArr.forEach((file:any) => {
      this.getBase64(file).then((reader:string)=>{
        this.attachFileList.push({
          "name": file.name,
          "contentType": file.type,
          "contentBytes": reader?.split(',')[1]
        }) 
      })
    })
    this.uploadedFiles$= of(this.attachFileList);
}

  // onChangePriority(data) {
  //   console.log(data, "priority-dropdown>>>>>>>>>>>>>>");
  // }
  discard() {
    this.replyForm.patchValue({
      to: '',
      priority: 'normal',
      cc: '',
      subject: '',
      editor: " "
    });
    this.commonkendoeditor.value="";
    this.uploadedFiles$ = of([]);
    this.discardDialog = false;
    this.replyForm.markAsUntouched();
  }
  commonkendoeditorimageuploaddialog() {    
    this.commonkendoeditorupload.open();
  }

  checkduplicateEmail(): ValidatorFn {
    return (group: FormGroup): { [s: string]: boolean } => {
      if(this.replyForm){
          const to =  this.replyForm.get('to').value
          const cc =  this.replyForm.get('cc').value
          if(to!=null && cc!=null )
          {
              if (to && cc) {
                let toArr = to.split(",");
                for(let toEmail of toArr){
                    if(cc.includes(toEmail)){
                      return { duplicateEmail: true };
                    }
                }
              }
          }
          // else if(to!=null && cc==null ){
          //   return { duplicateEmail: false };
          // }
        }
      return null;
    };
  }

  ngOnDestroy() { 
    // this.emailDetailSubscription.unsubscribe();
  }
}
